import { Suspense } from "react";
import { Outlet } from "react-router";

import { AppHeader } from "@/components/app-header";
import { FullPageLoader } from "@/components/protected-route";

interface AreaLayoutProps {
  /** Which area this is, shown in the header: "BOI cockpit" or "Client portal". */
  side: string;
}

/** The frame of the cockpit and the portal: the shared header over the area's page. */
export function AreaLayout({ side }: AreaLayoutProps) {
  return (
    <div className="bg-background min-h-screen">
      <AppHeader side={side} />
      {/* The pages load as their own chunks; the header stays while one arrives. */}
      <Suspense fallback={<FullPageLoader />}>
        <Outlet />
      </Suspense>
    </div>
  );
}
